export default function FancyHeader({ Subtitle, title }) {
  return (
    <div className="flex flex-grow flex-col md:gap-2 lg:flex-none">
      <span className="font-semibold italic text-primary-400">{Subtitle}</span>
      <h2 className="text-xl font-semibold md:text-2xl lg:text-4xl lg:font-bold">{title}</h2>
    </div>
  );
}
